(function() {
  // Flag to prevent infinite loops
  let isUpdating = false;
  
  // Function to check if we're on a product page
  function isProductPage() {
    const path = window.location.pathname;
    // Check if URL contains /products/ AND has a product handle after it
    if (path.includes('/products/') && path.split('/products/')[1]) {
      console.log('On product page - skipping title updates');
      return true;
    }
    return false;
  }
  
  // Function to check if there are filter parameters in the URL
  function hasFilterInUrl() {
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    
    // Check for common filter parameters
    const filterParams = ['filter.', 'sort_by', 'price_min', 'price_max'];
    
    for (const param of filterParams) {
      if (Array.from(searchParams.keys()).some(key => key.includes(param))) {
        return true;
      }
    }
    
    return false;
  }
  
  // Function to update product titles based on filter state
  function updateProductTitles() {
    // Skip completely if we're on a product page
    if (isProductPage()) return;
    
    if (isUpdating) return;
    isUpdating = true;
    
    console.log('Checking filter state and updating titles');
    
    // Check if filters are active from either the form or URL
    const filtersActiveInForm = document.querySelector('[data-filter-form][data-filters-active="true"]') !== null;
    const filtersActiveInUrl = hasFilterInUrl();
    const filtersActive = filtersActiveInForm || filtersActiveInUrl;
    
    console.log('Filters active in form:', filtersActiveInForm);
    console.log('Filters active in URL:', filtersActiveInUrl);
    console.log('Filters active (combined):', filtersActive);
    
    // Find all products
    const products = document.querySelectorAll('.product-item');
    let updatedCount = 0;
    
    products.forEach(product => {
      const titleElement = product.querySelector('.product-item__product-title a');
      if (!titleElement) return;
      
      // If product has parent group data
      if (product.hasAttribute('data-parent-group')) {
        const parentGroup = product.getAttribute('data-parent-group');
        
        // Store original title if we haven't already
        if (!product.hasAttribute('data-original-title') && titleElement.textContent.trim() !== parentGroup.trim()) {
          product.setAttribute('data-original-title', titleElement.textContent.trim());
        }
        
        // If no original title stored yet, use the product's data-title attribute
        if (!product.hasAttribute('data-original-title') && product.hasAttribute('data-title')) {
          product.setAttribute('data-original-title', product.getAttribute('data-title'));
        }
        
        // Get original title (fallback to data-title if not set)
        const originalTitle = product.getAttribute('data-original-title') || 
                              product.getAttribute('data-title') || 
                              titleElement.textContent.trim();
        
        // If filters active, show original title; otherwise show parent group
        if (filtersActive) {
          if (titleElement.textContent.trim() !== originalTitle) {
            titleElement.textContent = originalTitle;
            updatedCount++;
          }
        } else {
          if (titleElement.textContent.trim() !== parentGroup.trim()) {
            titleElement.textContent = parentGroup.trim();
            updatedCount++;
          }
        }
      }
    });
    
    console.log(`Updated ${updatedCount} product titles`);
    setTimeout(() => { isUpdating = false; }, 50);
  }
  
  // Initialize observers
  function initTitleManager() {
    // Skip initialization completely if we're on a product page
    if (isProductPage()) {
      console.log('On product page - not initializing title manager');
      return;
    }
    
    console.log('Initializing product title manager for collection page');
    
    // Update immediately on page load to handle shared URLs with filters
    updateProductTitles();
    
    // Another update after a short delay to catch any async loading
    setTimeout(updateProductTitles, 500);
    
    // Watch for filter changes
    const filterForms = document.querySelectorAll('[data-filter-form]');
    filterForms.forEach(form => {
      // Listen for filter activation
      form.addEventListener('change', function() {
        console.log('Filter form changed');
        setTimeout(updateProductTitles, 600);
      });
      
      // Observer for data-filters-active attribute changes
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'data-filters-active') {
            console.log('Filter active state changed');
            setTimeout(updateProductTitles, 600);
          }
        });
      });
      
      observer.observe(form, { attributes: true });
    });
    
    // Watch for product grid updates
    const resultsContainer = document.querySelector('[data-results-container]');
    if (resultsContainer) {
      const gridObserver = new MutationObserver(function() {
        if (!isUpdating) {
          setTimeout(updateProductTitles, 300);
        }
      });
      
      gridObserver.observe(resultsContainer, { 
        childList: true,
        subtree: true 
      });
    }
    
    // Also react to URL changes (for when filters are applied via URL)
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        console.log('URL changed, likely filter applied');
        
        // Check if we navigated to a product page
        if (isProductPage()) {
          console.log('Navigated to product page - stopping title updates');
          return;
        }
        
        setTimeout(updateProductTitles, 800);
      }
    }).observe(document, {subtree: true, childList: true});
  }
  
  // Start everything when document is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTitleManager);
  } else {
    initTitleManager();
  }
})();